export enum CandidateSignalAction {
  NoActionRequired = 0,
  CreateExtension = 1,
  ReviewExtension = 2,
  ViewExtension = 3,
  CreateContract = 4,
  ViewContract = 5,
  /** Provisional until the list/card API emits this signal. */
  RejectedByApprover = 6,
  /** Provisional until the list/card API emits this signal. */
  RejectedBySignee = 7,
  /** Provisional until the list/card API emits this signal. */
  ReviewRequest = 8,
  /** Provisional until the list/card API emits this signal. */
  ViewRequest = 9,
  /** Provisional until the list/card API emits this signal. */
  SupplierCardInfo = 10,
}
